import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TitleH5WhiteBold, TitleH6SemiBold } from '@/theme/OwnGlobalStylesComponents/StyleText';

import { ImageContainer, TextContainer } from './styles';

function Cover() {
  const { t } = useTranslation();
  return (
    <Container>
      <ImageContainer>
        <TextContainer>
          <TitleH6SemiBold>{t('BLOG.COVER_TITLE')}</TitleH6SemiBold>
          <TitleH5WhiteBold>{t('BLOG.COVER_SUBTITLE')}</TitleH5WhiteBold>
        </TextContainer>
      </ImageContainer>
    </Container>
  );
}

export default Cover;
